import React from 'react';
import MarkdownPage from '../Components/InfoPages/MarkdownPage';

function CareersPage() {
  return <MarkdownPage slug="careers" titleKey="infoPages.careers.title" descriptionKey="infoPages.careers.description" />;
}

export default CareersPage;
